import { render, staticRenderFns } from "./CommisionUserModal.vue?vue&type=template&id=5979afcb&scoped=true&"
import script from "./CommisionUserModal.vue?vue&type=script&lang=ts&"
export * from "./CommisionUserModal.vue?vue&type=script&lang=ts&"
import style0 from "./CommisionUserModal.vue?vue&type=style&index=0&id=5979afcb&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5979afcb",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VIcon,VTextField})
